// Mock data for Ekta Power & Green Energy Solutions

export const mockServices = [
  {
    id: 1,
    title: "Residential Solar Installation",
    description: "Complete rooftop solar solutions for homes. Reduce your electricity bills by up to 80% with our premium solar systems.",
    icon: "Home",
    features: ["3kW to 10kW systems", "Net metering support", "25-year panel warranty", "AMC support available"]
  },
  {
    id: 2,
    title: "Commercial & Industrial Solar",
    description: "Large-scale solar projects for businesses and industries. Maximize ROI with our efficient commercial solar solutions.",
    icon: "Building2",
    features: ["10kW to 1MW+ systems", "Custom design", "Subsidy assistance", "Complete turnkey solutions"]
  },
  {
    id: 3,
    title: "Solar Battery Storage",
    description: "Store excess solar energy for 24/7 power availability. Never worry about power cuts again.",
    icon: "Battery",
    features: ["Lithium-ion batteries", "Smart energy management", "10-year warranty", "Seamless integration"]
  },
  {
    id: 4,
    title: "Maintenance & AMC Services",
    description: "Keep your solar system running at peak efficiency with our comprehensive maintenance services.",
    icon: "Wrench",
    features: ["Regular cleaning", "Performance monitoring", "Quick repairs", "Annual inspections"]
  }
];

export const mockBenefits = [
  {
    id: 1,
    title: "Reduce Electricity Bills",
    description: "Save up to 80% on your monthly electricity costs",
    icon: "TrendingDown"
  },
  {
    id: 2,
    title: "Government Subsidies",
    description: "Avail up to 40% central government subsidy on residential solar",
    icon: "BadgeIndianRupee"
  },
  {
    id: 3,
    title: "Fast ROI",
    description: "Recover your investment in just 3-5 years",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Eco-Friendly Energy",
    description: "Reduce carbon footprint and contribute to a greener planet",
    icon: "Leaf"
  }
];

export const mockProcess = [
  {
    step: 1,
    title: "Site Visit",
    description: "Our experts visit your location to assess solar potential and roof structure"
  },
  {
    step: 2,
    title: "System Design",
    description: "We design a customized solar system based on your energy needs and budget"
  },
  {
    step: 3,
    title: "Installation",
    description: "Professional installation by certified technicians within 3-5 days"
  },
  {
    step: 4,
    title: "Net Metering & Approval",
    description: "We handle all paperwork and government approvals for net metering"
  },
  {
    step: 5,
    title: "Support & Maintenance",
    description: "Ongoing support and maintenance to ensure optimal system performance"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    location: "Pune, Maharashtra",
    rating: 5,
    text: "Installed a 5kW system 2 years ago. My electricity bill dropped from ₹8,000 to just ₹800! Amazing service and professional team.",
    type: "Residential",
    image: "https://ui-avatars.com/api/?name=Rajesh+Sharma&background=059669&color=fff"
  },
  {
    id: 2,
    name: "Priya Deshmukh",
    location: "Mumbai, Maharashtra",
    rating: 5,
    text: "Best decision for our home! The installation was smooth, and the team guided us through the subsidy process. Highly recommended.",
    type: "Residential",
    image: "https://ui-avatars.com/api/?name=Priya+Deshmukh&background=059669&color=fff"
  },
  {
    id: 3,
    name: "Suntech Industries",
    location: "Pune, Maharashtra",
    rating: 5,
    text: "Ekta Power installed a 100kW system for our factory. We're saving ₹1.2 lakhs monthly! Professional execution and excellent after-sales support.",
    type: "Commercial",
    image: "https://ui-avatars.com/api/?name=Suntech+Industries&background=2563eb&color=fff"
  },
  {
    id: 4,
    name: "Amit Patil",
    location: "Nashik, Maharashtra",
    rating: 5,
    text: "Installed 3kW system with battery backup. No more power cuts! The team was knowledgeable and installation was completed in 3 days.",
    type: "Residential",
    image: "https://ui-avatars.com/api/?name=Amit+Patil&background=059669&color=fff"
  },
  {
    id: 5,
    name: "Green Valley Resort",
    location: "Lonavala, Maharashtra",
    rating: 5,
    text: "50kW solar installation has transformed our energy costs. ROI achieved in just 4 years. Ekta Power's team was exceptional throughout.",
    type: "Commercial",
    image: "https://ui-avatars.com/api/?name=Green+Valley+Resort&background=2563eb&color=fff"
  }
];

export const mockROIData = [
  {
    capacity: "3kW",
    avgBillBefore: "₹4,000",
    avgBillAfter: "₹400",
    monthlySavings: "₹3,600",
    yearlySavings: "₹43,200",
    systemCost: "₹2,10,000",
    subsidy: "₹78,000",
    finalCost: "₹1,32,000",
    roi: "3 years"
  },
  {
    capacity: "5kW",
    avgBillBefore: "₹7,000",
    avgBillAfter: "₹700",
    monthlySavings: "₹6,300",
    yearlySavings: "₹75,600",
    systemCost: "₹3,50,000",
    subsidy: "₹78,000",
    finalCost: "₹2,72,000",
    roi: "3.5 years"
  },
  {
    capacity: "10kW",
    avgBillBefore: "₹14,000",
    avgBillAfter: "₹1,400",
    monthlySavings: "₹12,600",
    yearlySavings: "₹1,51,200",
    systemCost: "₹7,00,000",
    subsidy: "₹78,000",
    finalCost: "₹6,22,000",
    roi: "4 years"
  }
];

// Mock form submission
export const submitEnquiryForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({
        success: true,
        message: "Thank you! We'll contact you within 24 hours."
      });
    }, 1000);
  });
};
